import { OrderFormType } from '../forms/orderForm/type';

const DEPZ_CODE = 'DEPZ';

export const isRequiredAdditionalParameters = (values: OrderFormType) => {
  let isRequired = true;

  const senderDetailsCustodianOrganizationCode =
    values.senderDetails?.custodianOrganizationCode;

  const recipientDetailsCustodianOrganizationCode =
    values.recipientDetails?.custodianOrganizationCode;

  if (
    senderDetailsCustodianOrganizationCode &&
    recipientDetailsCustodianOrganizationCode
  ) {
    isRequired =
      senderDetailsCustodianOrganizationCode !== DEPZ_CODE ||
      recipientDetailsCustodianOrganizationCode !== DEPZ_CODE;
  }

  return isRequired;
};
